import { inServer } from "core-web/constants";

export const getUUID = () => {
    let UUID;

    if (!inServer) {
        UUID = window.localStorage.getItem("algolia-user-token");

        if (!UUID) {
            UUID = crypto.getRandomValues(new Uint32Array(1))[0];
            window.localStorage.setItem("algolia-user-token", UUID);
        }

        return UUID;
    }

    return null;
};
